var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"moules_basics"},[(_vm.typeText)?_c('div',{staticClass:"basics_title"},[_vm._v(_vm._s(_vm.typeText))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }